import { render, staticRenderFns } from "./GegContratC4.vue?vue&type=template&id=66135ca8"
import script from "./GegContratC4.vue?vue&type=script&lang=js"
export * from "./GegContratC4.vue?vue&type=script&lang=js"
import style0 from "./GegContratC4.vue?vue&type=style&index=0&id=66135ca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports